import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum OfferDiscountType {
  PERCENTAGE = 'percentage',
  AMOUNT = 'amount',
  COUPON = 'coupon',
}

export class OfferDiscountTypeOption extends Codebook<OfferDiscountType> {
  static readonly PERCENTAGE = new OfferDiscountTypeOption(OfferDiscountType.PERCENTAGE, () =>
    $t('Percentage'),
  )
  static readonly AMOUNT = new OfferDiscountTypeOption(OfferDiscountType.AMOUNT, () => $t('Amount'))
  static readonly COUPON = new OfferDiscountTypeOption(OfferDiscountType.COUPON, () =>
    $t('Discount coupon'),
  )

  private constructor(
    id: OfferDiscountType,
    public readonly name: () => string,
  ) {
    super(id)
  }
}
